import { dynamicLoader } from '~/utils';

export const ContactEditor = dynamicLoader({
  name: 'ContactEditorWrapper',
  importFunc: () => import('./contact-editor-wrapper'),
});
